<script>
import router from "../../router";
import Alert from "@/components/Alert";
export default {
  name: "ViewPurchaseOrder",
  components: {
    Alert
  },
  data() {
    return {
      order: {
        transfer_order: {},
        items: []
      },
      to_email: "",
      from_email: "",
      subject: "",
      cc_email: ""
    };
  },
  methods: {
    details(id) {
      this.$api
        .getAPI({
          _action: "/transfer-order/detail/" + id
        })
        .then(res => {
          this.order = res;

          this.subject =
            "Transfer from " +
            this.order.transfer_order.source_store_name +
            " to " +
            this.order.transfer_order.destination_store_name +
            " (" +
            this.order.transfer_order.to_number +
            ")";

          this.from_email = this.order.transfer_order.email;
        });
    },
    gettoback() {
      router.push("/transfer-orders");
    },
    edit() {
      if (this.order.transfer_order.id) {
        router.push("/edit-transfer-order/" + this.order.transfer_order.id);
      }
    },
    receive() {
      this.$refs.receiveOrderAlert.message = this.$lang.messages.are_you_sure_you_want_to_receive_all_items;
    },
    receiveOrder() {
      if (this.order.transfer_order.id) {
        this.$api
          .postAPI({
            _action: "/transfer-order/received/" + this.order.transfer_order.id,
            _body: null,
            _buttonId: "receive-btn"
          })
          .then(res => {
            this.$refs.receiveOrderAlert.close();
            this.$notify({
              group: "foo",
              text: res.message,
              type: "success"
            });

            router.push("/transfer-orders");
          })
          .catch(e => {
            this.$refs.receiveOrderAlert.close();
          });
      }
    },
    approve() {
      if (this.order.transfer_order.id) {
        this.$api
          .getAPI({
            _action: "/transfer-order/approve/" + this.order.transfer_order.id
          })
          .then(res => {
            this.details(this.order.transfer_order.id);
          });
      }
    },
    checkSend() {
      this.$validator.validateAll("modifier-form").then(result => {
        if (result) {
          this.sendMail1();
          return;
        }
      });
    },
    sendMail1() {
      var abc = {
        from_email: this.from_email,
        to_email: this.to_email,
        cc_email: this.cc_email,
        subject: this.subject,
        id: this.order.transfer_order.id
      };
      this.$api
        .postAPI({
          _action: "/transfer-order/send_mail",
          _body: abc,
          _buttonId: "save-btn"
        })
        .then(res => {
          this.$notify({
            group: "foo",
            text: res.message,
            type: "success"
          });
          document.getElementById("cancel-btn").click();
        })
        .catch(e => {
          console.log(e.message);
        });
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.details(this.$route.params.id);
    }
  }
};
</script>
<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-9">
            <div class="card rounded-5 border">
              <div class="card-header bg-white border-bottom px-lg-5 px-4 py-4">
                <div class="row">
                  <div class="col-lg-4 col-md-5 align-self-center mb-md-0 mb-3">
                    <a href="javascript:void(0)" @click="gettoback()" class="text-primary">
                      <i class="mdi mdi-chevron-left"></i>
                      {{$lang.messages.transfer_order}}
                    </a>
                  </div>
                  <div class="col-lg-8 col-md-7 text-right">
                    <a
                      v-if="order.transfer_order.transfer_status == 'TRANSIT'"
                      href="javascript:void(0)"
                      class="btn btn-outline-primary mr-2 mb-lg-0 mb-2"
                      style="min-width: auto"
                      @click="edit()"
                    >
                      <i class="mdi mdi-pencil"></i>
                    </a>
                    <button
                      v-if="order.transfer_order.transfer_status == 'TRANSIT'"
                      @click="receive()"
                      data-toggle="modal"
                      data-target="#receive-transfer-order-modal"
                      type="button"
                      id="receive-btn"
                      class="btn btn-primary mr-lg-2 mb-md-0 mb-3 w-xs-100"
                    >{{$lang.messages.receive}}</button>
                    <button
                      v-if="order.transfer_order.transfer_status == 'TRANSIT'"
                      type="button"
                      class="btn btn-primary mr-lg-2 mb-md-0 mb-3 w-xs-100"
                      data-toggle="modal"
                      data-target="#SendTransferOrder"
                    >{{$lang.messages.send}}</button>
                  </div>
                </div>
              </div>
              <div class="card-body form-style px-lg-5 px-4 py-4">
                <div class="row mb-4">
                  <div class="col-lg-9">
                    <h1 class="mb-0">{{order.transfer_order.to_number}}</h1>
                    <p class="text-danger font-14">{{$lang.messages[order.transfer_order.transfer_status.toUpperCase()]}}</p>
                  </div>
                </div>
                <div class="row mb-5">
                  <div class="col-lg-12">
                    <table>
                      <tr>
                        <td class="pr-3 f-semi-bold">{{$lang.messages.date}}:</td>
                        <td>{{order.transfer_order.transfer_date | moment("MMM DD, YYYY") }}</td>
                      </tr>
                      <tr>
                        <td class="f-semi-bold pr-3">{{$lang.messages.ordered_by}}:</td>
                        <td>{{order.transfer_order.orderedBy}}</td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-lg-6">
                    <h4 class="mb-3 f-semi-bold">{{$lang.messages.source_store}}:</h4>
                    <p>{{order.transfer_order.source_store_name}}</p>
                  </div>
                  <div class="col-lg-6">
                    <h4 class="mb-3 f-semi-bold">{{$lang.messages.destination_store}}:</h4>
                    <p>
                      {{order.transfer_order.destination_store_name}}
                      <br />
                    </p>
                  </div>
                  <div class="col-12 mt-4" v-if="order.transfer_order.notes">
                    <p class="f-semi-bold mb-0">{{$lang.messages.notes}}:</p>
                    <p>{{order.transfer_order.notes}}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12">
                    <h3>{{$lang.messages.items}}</h3>
                    <table class="table table-striped table-style-1 table-responsive">
                      <thead>
                        <tr>
                          <th scope="col">{{$lang.messages.item}}</th>
                          <th scope="col" class="text-right">{{$lang.messages.quantity}}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="obj in order.items" :key="obj.id">
                          <td>
                            {{obj.item.name}}
                            <br />
                            <span
                              class="font-14 text-grey"
                              v-if="obj.item.sku"
                            >{{$lang.messages.sku}} {{obj.item.sku}}</span>
                          </td>
                          <td class="text-right">{{obj.item.quantity}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Alert
      @rightButtonEvent="receiveOrder($event)"
      v-bind:title="$lang.messages.receive_transfer_order"
      ref="receiveOrderAlert"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="receive-transfer-order-modal"
    />
    <!-- Modal Box send -->
    <div
      class="modal fade"
      id="SendTransferOrder"
      tabindex="-1"
      role="dialog"
      aria-labelledby="SendTransferOrder"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content px-lg-4 py-lg-4">
          <div class="modal-header border-0">
            <h5 class="modal-title font-22">{{$lang.messages.send_transfer_order_by_email}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form data-vv-scope="modifier-form">
            <div class="modal-body form-style">
              <div class="row mb-4">
                <div class="col-lg-12 mb-3">
                  <label for>{{$lang.messages.from}}</label>
                  <span style="color:#ff0000">*</span>
                  <input
                    name="from_email"
                    v-model="from_email"
                    v-validate="'required|email'"
                    :class="{ 'form-control' : true, 'input': true, 'is-danger': errors.has('modifier-form.from_email') }"
                    type="text"
                    v-bind:placeholder="$lang.messages.email"
                  />
                  <i v-show="errors.has('modifier-form.from_email')" class="fa fa-warning"></i>
                  <span
                    v-show="errors.has('modifier-form.from_email')"
                    class="help is-danger"
                  >{{$lang.messages.please_enter_email}}</span>
                </div>

                <div class="col-lg-12 mb-3">
                  <label for>{{$lang.messages.to}}</label>
                  <span style="color:#ff0000">*</span>
                  <input
                    name="to_email"
                    v-model="to_email"
                    v-validate="'required|email'"
                    :class="{ 'form-control' : true, 'input': true, 'is-danger': errors.has('modifier-form.to_email') }"
                    type="text"
                    v-bind:placeholder="$lang.messages.email"
                  />
                  <i v-show="errors.has('modifier-form.to_email')" class="fa fa-warning"></i>
                  <span
                    v-show="errors.has('modifier-form.to_email')"
                    class="help is-danger"
                  >{{$lang.messages.please_enter_email}}</span>
                </div>
                <div class="col-lg-12 mb-3">
                  <label for>Cc</label>
                  <input
                    name="cc_email"
                    v-model="cc_email"
                    v-validate="'email'"
                    :class="{ 'form-control' : true, 'input': true, 'is-danger': errors.has('modifier-form.cc_email') }"
                    type="text"
                    v-bind:placeholder="$lang.messages.email"
                  />
                  <i v-show="errors.has('modifier-form.cc_email')" class="fa fa-warning"></i>
                  <span
                    v-show="errors.has('modifier-form.cc_email')"
                    class="help is-danger"
                  >{{$lang.messages.please_enter_email}}</span>
                </div>
                <div class="col-lg-12 mb-4">
                  <label for>{{$lang.messages.subject}}</label>
                  <input type="text" name="subject" v-model="subject" class="form-control" id />
                </div>
                <div class="col-lg-12">
                  <label class="mb-0">{{$lang.messages.message}}</label>
                  <p class="font-14 text-grey">{{$lang.messages.attachment}}</p>
                  <p class>
                    <i class="mdi mdi-file-pdf mr-2"></i>
                    {{order.transfer_order.to_number}}
                  </p>
                </div>
              </div>
            </div>
            <div class="modal-footer border-0 justify-content-center">
              <button
                type="button"
                class="btn btn-primary mr-3"
                id="save-btn"
                @click="checkSend()"
              >{{$lang.messages.send}}</button>
              <button
                type="button"
                data-dismiss="modal"
                id="cancel-btn"
                class="btn btn-outline-primary"
              >{{$lang.messages.cancel_btn_text}}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>